import request from "@utils/request";

const state = "roles";

const list = async (customConfig?: any) => {
  return await request({
    url: state,
    method: "GET",
    config: { store: { action: "set", key: state, ...customConfig } },
    authorization: true,
  });
};

const find = async (id: number) => {
  return await request({
    url: `${state}/${id}`,
    method: "GET",
    authorization: true,
  });
};

const create = async (data: any) => {
  return await request({
    url: state,
    method: "POST",
    data,
    authorization: true,
  });
};

const update = async (id: number, data: any) => {
  return await request({
    url: `${state}/${id}`,
    method: "PUT",
    data,
    authorization: true,
  });
};

const remove = async (id: number) => {
  return await request({
    url: `${state}/${id}`,
    method: "DELETE",
    authorization: true,
  });
};

export default { list, find, create, update, remove };
